import React, { useEffect, useState } from "react";
import {
  getAttendanceDetails,
  getDailyVisitDetails,
} from "_controllers/officer";
import { DateTime } from "luxon";
import { useParams } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Modal,
  Button,
  Typography,
  TableContainer,
  Paper,
  Grid,
  TextField,
  CircularProgress
} from "@mui/material";
import moment from "moment";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Box } from "@mui/system";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';

const messageStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: '#ffffff',
  border: "none",
  boxShadow: 24,
  pt: 2,
  pb: 0,
  pl: 4,
  pr: 4,
  textAlign: 'left',
  letterSpacing: 1
};

const DailyVist = () => {
  const { SAP_ID } = useParams();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [visitDetails, setVisitDetails] = useState([])
  const [message, setMessage] = useState("");
  const [onDate, setOnDate] = useState('')

  // const { ondate } = Values

  useEffect(async () => {
    const todayDate = onDate ? onDate : moment(new Date()).format("YYYY-MM-DD");

    const plan = await getDailyVisitDetails({
      SAP_ID,
      todayDate,
    });
    console.log("object", plan.newData);
    setData(plan?.newData);
    setLoading(true);
  }, [message, onDate]);

  const timeSpent = (a, b) => {
    const test = moment.duration(moment(b ? b : "").diff(moment(a ? a : "")));
    return `${test.asMinutes().toFixed(0)} mins`;
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (e) => {
    setOnDate(e.target.value)
  }

  const approvedStyle = {
    color: 'green',
    fontWeight: "bolder"
  }

  const revertedStyle = {
    color: "red",
    fontWeight: "bolder"
  }

  return (
    <>
      {/* // change static data in url endpoint*/}
      <Box>
        <form>
          <Grid container xs={12} sx={{ m: 1 }}>
            <Grid container xs={5} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Grid item xs={3}>
                <h5>On Date :</h5>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  type={'date'}
                  sx={{ width: '80%' }}
                  onChange={handleChange}
                  value={onDate}
                  name="onDate"
                  variant="outlined"
                />
              </Grid>
            </Grid>
            {/* <Grid item xs={2} style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center' }}>
              <FilterAltOutlinedIcon sx={{ border: '1px solid darkgrey', fontSize: '45px', borderRadius: '3px', cursor: 'pointer' }} onClick={handleSubmit} />
              <DownloadIcon sx={{ border: '1px solid darkgrey', fontSize: '45px', borderRadius: '3px', cursor: 'pointer' }} onClick={generateExcel} />
            </Grid> */}
          </Grid>
        </form>
      </Box>
      {loading ? (
        <>
          <TableContainer component={Paper} sx={{ mt: 3, mb: 2.5 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Date</TableCell>
                  <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Dealer Code</TableCell>
                  <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Dealer Details</TableCell>
                  <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Type</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Visit Action</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Time Spent</TableCell>
                </TableRow>
              </TableHead>

              {data?.length > 0
                ? data?.map((d) => (
                  d.deleted === true ? <TableBody>
                    <TableRow key={d._id}>
                      <TableCell align="left">
                        <s>{moment(d?.startTime).format("YYYY-MM-DD")}</s>
                      </TableCell>
                      <TableCell align="left"><s>{d?.dealerCode}</s></TableCell>
                      <TableCell align="left"><s>{d?.dealerDetails?.name}</s></TableCell>
                      <TableCell align="left" style={d.unplanned ? revertedStyle : approvedStyle}><s>{d?.unplanned ? "Unplanned" : "Planned"}</s></TableCell>
                      <TableCell
                        align='center'
                        onClick={() => {
                          setOpen(true);
                          setVisitDetails(d?.visitActions)
                        }}
                      >
                        <VisibilityIcon
                          style={{ cursor: 'pointer' }}
                          onClick={() => setOpen(true)}
                        />
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ cursor: "pointer" }}
                      >
                        <s>{d.deleted === false ? timeSpent(d?.startTime, d?.endTime) : "NA"}</s>
                      </TableCell>
                    </TableRow>
                  </TableBody> :
                    <TableBody>
                      <TableRow key={d._id}>
                        <TableCell align="left">
                          {moment(d?.startTime).format("YYYY-MM-DD")}
                        </TableCell>
                        <TableCell align="left">{d?.dealerCode}</TableCell>
                        <TableCell align="left">{d?.dealerDetails?.name}</TableCell>
                        <TableCell align="left" style={d.unplanned ? revertedStyle : approvedStyle}>{d?.unplanned ? "Unplanned" : "Planned"}</TableCell>
                        <TableCell
                          align='center'
                          onClick={() => {
                            setOpen(true);
                            setVisitDetails(d?.visitActions)
                          }}
                        >
                          <VisibilityIcon
                            style={{ cursor: 'pointer' }}
                            onClick={() => setOpen(true)}
                          />
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ cursor: "pointer" }}
                        >
                          {timeSpent(d?.startTime, d?.endTime)}
                        </TableCell>
                      </TableRow>
                    </TableBody>))
                :
                <Box sx={{ textAlign: 'left', pt: 1 }}>
                  <Typography variant="h6" sx={{ p: 1 }}>No Visit's Available on {onDate ? onDate : moment(new Date()).format("YYYY-MM-DD")}</Typography>
                </Box>}
            </Table>
          </TableContainer>
        </>
      ) : (
        <CircularProgress />
      )
      }
      <Modal open={open} onClose={handleClose}>
        <Box sx={messageStyle}>
          <Table aria-label="simple table">
            <TableHead >
              <TableRow >
                <TableCell align='left' sx={{ fontWeight: 'bolder' }}>Type</TableCell>
                <TableCell sx={{ fontWeight: 'bolder' }}>Action Taken</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {visitDetails?.length > 0 ? (
                visitDetails.map((row) => (
                  <TableRow key={row._id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell align="left" scope="row" style={{ borderBottom: '1px solid rgba(224, 224, 224, 1)' }}>{row?.type}</TableCell>
                    <TableCell align="center" scope="row" style={{ borderBottom: '1px solid rgba(224, 224, 224, 1)' }}>{row?.actionTaken}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow key={'1'} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                  <TableCell colSpan={3} align="center">
                    No Visit Action Available.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          <Box sx={{ m: 3, display: 'flex', justifyContent: 'center' }}>
            <Button variant="contained" onClick={() => setOpen(false)}>Close</Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default DailyVist;
